import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "px-6 py-16 sm:py-20 text-center" }
const _hoisted_2 = { class: "inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 bg-slate-100 rounded-full mb-5 sm:mb-6" }
const _hoisted_3 = { class: "text-slate-900 font-bold text-lg sm:text-xl mb-2" }
const _hoisted_4 = { class: "text-slate-600 text-sm sm:text-base max-w-md mx-auto" }
const _hoisted_5 = {
  key: 0,
  class: "mt-6 flex justify-center"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminEmptyState',
  props: {
    title: { default: "No se encontraron resultados" },
    description: { default: "Intenta ajustar los filtros o crear un nuevo registro." }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "icon", {}, () => [
        _cache[0] || (_cache[0] = _createElementVNode("svg", {
          class: "w-8 h-8 sm:w-10 sm:h-10 text-slate-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
          "aria-hidden": "true"
        }, [
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
          })
        ], -1))
      ])
    ]),
    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.title), 1),
    _createElementVNode("p", _hoisted_4, _toDisplayString(__props.description), 1),
    (_ctx.$slots.actions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "actions")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})